module.exports = __webpack_public_path__ + "img/album17_02.e0321001.jpg";